import React, { useState, useEffect } from 'react';

const Form = ({children, validate, defaults = {}, onSubmit, ...props}) => {
    const [data, setData] = useState(defaults);
    const [validation, setValidation] = useState(validate.get() || {});

    // Commented this out and forms work again...
    // I cannot remember why this was added...
    // Looks like resetting it resulted in everything always being fine...?
    // validate.reset();

    const onChange = (name, value) => {
        if (! data.hasOwnProperty(name)) {
            // add the name to our data if it does not exist
            setData({
                ...data,
                [name]: value
            });
        }

        if (value === undefined) {
            // if no value is provided, assume we want a factory
            // which will create an onChange event handler.
            return e => onChange(name, e);
        }

        setData({
            ...data,
            [name]: value.currentTarget
                ? value.currentTarget.value
                : value
        });
    }

    const handleSubmit = e => {
        e.preventDefault();
        const validation = validate(data);

        if (! validation.hasErrors()) {
            onSubmit(data, setData);
        }

        setValidation(validation);
    }

    return <form {...props} onSubmit={handleSubmit}>
        {children(data, onChange, validation)}
    </form>;
};

export default Form;